import { useState } from 'react';
import Modal from '@mui/material/Modal';
import Close from '@mui/icons-material/Close';
import './MigrateFolderForm.scss';

export default function MigrateFolderForm(props) {

    const [cursor] = useState('auto');
    const className = 'migrateFolderForm';

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}>
                <div className={className}>
                    <div className={className + '__inner'}>
                        <div className={className + '__inner__titleBar'}>
                            <text className={className + '__inner__titleBar__title standard-text-semi-large'}>
                                Migrate Folder
                            </text>
                            <Close className={className + '__inner__titleBar__icons__close close-button'}
                                onClick={props.closePopup}/>
                        </div>
                    </div>
                </div>
        </Modal>
    )
}